// components/ConfirmDialog.js
import React from 'react';
import {
    Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';

const ConfirmDialog = ({ open, loading, success, error, appId, message, onConfirm, onCancel , onDownload }) => {
  const getTitle = () => {
    if (success) return "✅ تم الإرسال بنجاح";
    if (error) return "❌ حدث خطأ أثناء الإرسال";
    return "تأكيد الإرسال";
  };

  const getContent = () => {
    if (loading) {
      return (
        <Typography align="center" sx={{ mt: 2, mb: 2 }}>
          <CircularProgress size={24} sx={{ mr: 1 }} />
          جاري تحميل التقرير...
        </Typography>
      );
    }

    if (success) {
      return (
        <>
         <Typography align="center" sx={{ mt: 2, mb: 2 }}>
      ✅ تم إرسال البيانات بنجاح <br />
      <strong>رقم المعاملة: {appId}</strong>
    </Typography>
    <Box textAlign="center" sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={onDownload}
            >
              تحميل التقرير PDF
            </Button>
          </Box>
    <Box textAlign="center" sx={{ mt: 2 }}>
      <Button
        variant="contained"
        color="success"
        onClick={() => window.location.reload()}
      >
        إغلاق
      </Button>
    </Box>
    </>
      );
    }

    if (error) {
      return (
        <Typography align="center" color="error" sx={{ mt: 2, mb: 2 }}>
           {message || "حدث خطأ أثناء إرسال البيانات. يرجى المحاولة مرة أخرى."}
        </Typography>
      );
    }

    return (
      <Typography>
        هل أنت متأكد من أنك تريد إرسال هذه البيانات؟
      </Typography>
    );
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{getTitle()}</DialogTitle>
      <DialogContent>{getContent()}</DialogContent>
      <DialogActions>
        {!loading && !success && (
          <>
            <Button onClick={onCancel} color="secondary">
              إلغاء
            </Button>
            <Button onClick={onConfirm} variant="contained" color="primary">
              تأكيد الإرسال
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
